export default __webpack_public_path__ + "static/media/approveBtn.11354cfd.svg";